import React from 'react';

export interface PreferencesSaveBarProps {
  visible: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

export function PreferencesSaveBar({ visible, onDiscard, onSave }: PreferencesSaveBarProps): React.JSX.Element | null {
  if (!visible) return null;

  return (
    <div className="savebar-floating">
      <div className="savebar-status">
        <span className="savebar-pulse"></span>
        <span>Unsaved changes to preferences</span>
      </div>
      <div className="savebar-actions">
        <button type="button" className="savebar-btn discard" onClick={onDiscard}>Discard</button>
        <button type="button" className="savebar-btn save" onClick={onSave}>Save Settings</button>
      </div>
    </div>
  );
}
